import Modal from 'react-bootstrap/Modal';
import Button from '../../../Components/Button/Button';
import { useEffect, useState } from 'react';
import { ObtenerLogInforme } from '../Services/ObtenerLogInforme';
import useLogin from '../../Autenticacion/Hooks/useLogin';

const ModalLog = (props) => {
	const { onHide, datosModal, ...rest } = props;
	const { usuario } = useLogin();
	const [errores, setErrores] = useState("")

	useEffect(()=>{
		if(datosModal.informeConservacionId){
			postObtenerLogInforme();
		}
	},[datosModal]);

	const postObtenerLogInforme = async () => {
		const values = {
			idUsuario: usuario.id,
			informeConservacionId: datosModal.informeConservacionId
		};
		const resp = await ObtenerLogInforme(values);
		if (resp) {
			if (resp.status === 200) {
				setErrores(resp.data.listadoInformes);
			} else if (resp.status === 206) {
				onHide();
			}
		}
	};

	return (
			<Modal
					{...props}
					size="lg"
					centered
					keyboard="false"
			>
					<Modal.Header>
							<h5 className="modal-title">Log del Archivo</h5>
							<Button type="button" design="btn-outline-pewter-blue p-2 lh-1 fs-3" onClick={() => {onHide();}}><i className='ico-close'></i></Button>
					</Modal.Header>
					<Modal.Body className='p-4 gap-4 d-flex flex-column'>
					<div>
                        <div className='accordion-body p-0 '>
                            
                            <h6 className='mb-3'>Errores detectados:</h6>
                            <div style={{
									maxHeight: '200px', // Limita la altura a 200px
									overflowY: 'auto', // Activa el scroll vertical
									border: '1px solid #dee2e6', // Opcional: añade borde para mayor claridad
									padding: '10px', // Opcional: añade padding interno
									borderRadius: '5px', // Opcional: bordes redondeados
								}}>
                                <ul>
                                {errores.length>0 &&
									errores.map((error, index) => (
										<li key={index}
										dangerouslySetInnerHTML={{ __html: error.observaciones || ''}}>
									</li>
									))
								}
                                </ul>
                            </div>

                        </div>
					</div>
					</Modal.Body>
			</Modal>
	)
}

export default ModalLog
